<template>
  <a class="dropdown-item cursor-pointer" @click="handle">Delete message</a>
</template>

<script>
export default {
  props: {
    message: Object,
    url: String,
  },

  methods: {
    /**
     * @return {undefined}
     */
    handle() {
      return axios.delete(this.url)
          .then(this.onDeleted)
          .catch(this.onDeletedError);
    },

    /**
     * @event load-schedule-message-list
     * @event conversation-list-change
     * @return {undefined}
     */
    onDeleted({data: {message}}) {
      eventBus.$emit('load-schedule-message-list');

      if (!_.isNull(message)) {
        this.$message({
          message: message,
          type: 'success',
        });
      }
    },

    /**
     * @param {Object} response
     * @return {undefined}
     */
    onDeletedError({response}) {
      this.$message({
        message: _.get(response, 'data.message', 'An error occurred.'),
        type: 'error',
        iconClass: 'el-icon-error',
      });
    },
  },
}
</script>

<style scoped>

</style>
